export const Network = {
    Distributor: 4909
};



// WEBPACK FOOTER //
// ./src/enuns/AfterSales/network.js